import { render, staticRenderFns } from "./ThresholdAlertEditor.vue?vue&type=template&id=1b3c739c&scoped=true&"
import script from "./ThresholdAlertEditor.vue?vue&type=script&lang=ts&"
export * from "./ThresholdAlertEditor.vue?vue&type=script&lang=ts&"
import style0 from "./ThresholdAlertEditor.vue?vue&type=style&index=0&id=1b3c739c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b3c739c",
  null
  
)

export default component.exports